// extracted by mini-css-extract-plugin
export default {"SemiBold":"_SemiBold--q7xOS","Insight":"_Insight--j00i4"};